import PitaliyColorLoader from "@/v2/components/PitaliyColorLoader";

function Loading({ className }: { className?: string }) {
  return (
    <div
      className={`w-screen h-screen flex flex-col items-center justify-center fixed top-0 left-0 z-50 bg-black/30 ${className}`}
    >
      <PitaliyColorLoader size={28} />
    </div>
  );
}

export default Loading;
